import React from "react";
import "./WhyChooseUs.css";
import { motion } from "framer-motion";

const cards = [
  {
    title: "Clear, brand-specific paths",
    text: "HP, Canon, Epson, Brother, Netgear, TP‑Link, Linksys, D‑Link — start where your device already is.",
  },
  {
    title: "Live help when stuck",
    text: "Error codes and pairing loops don’t have to end the day. Specialists guide you through the fix.",
  },
  {
    title: "Built for non-experts",
    text: "Plain language, one job per screen, and confirmation when the setup actually worked.",
  },
  {
    title: "Fast to start",
    text: "Jump into printer or extender help in seconds — no account maze before you begin.",
  },
];

const WhyChooseUs = () => (
  <section className="why" id="why-choose">
    <div className="why__grid">
      {cards.map((c, idx) => (
        <motion.article
          key={c.title}
          className="why__card"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55, delay: idx * 0.06 }}
        >
          <h3>{c.title}</h3>
          <p>{c.text}</p>
        </motion.article>
      ))}
    </div>
  </section>
);

export default WhyChooseUs;
